import uniqid from 'uniqid';

if (!localStorage.getItem('id')) {
  localStorage.setItem('id', uniqid());
}

const initialFormState = {
  // id: localStorage.getItem('id'),
  baseURL: '',
  initialPageCompleted: false,
  alreadyWorkWithUs: false,
  step: 0,
  Restaurant_cid: '',
  failedRestaurantSearch: false,
  failedPromoCode: false,
  Restaurant_id: '',
  showRestaurantSearch: true,
  Signup_type: '',
  promocode: '',
  everCameFromPromo: false,
  menu_id: '',
  Google_phone: '',
  version: null,
  Restaurant_address: '',
  Restaurant_alias: '',
  Restaurant_found: '',
  Nav_page_2: '',
  Opened_sample_menu: '',
  Owner_name: '',
  Owner_phone: '',
  Did_place_test_order: '',
  Matched_restaurant_uuid: '',
  Finished_form: '',
  Alternate_number: '',
  Page_language: 'English',
  facebook: false
};

export default initialFormState;
